<!-- =========================================================================================
  File Name: actualites.vue
  Description: actualites Page
  ----------------------------------------------------------------------------------------

========================================================================================== -->

<template>
<div id="actualites-page">
    <fournisseur-act v-if="showFournisseur"></fournisseur-act>
    <actualites-clients v-if="showClient"></actualites-clients>
    <actualites-admin v-if="showGestionnaire"></actualites-admin>
</div>
</template>

<script>
import FournisseurAct from "./actualites/fournisseurAct.vue";
import ActualitesClients from "./actualitesClient/main.vue";
import ActualitesAdmin from '@/views/adminportail/actualitesadmin.vue'
import authService from "@/auth/authService.js";
export default {
    data() {
        return {
            showFournisseur: false,
            showClient: false,
        };
    },
    components: {
        FournisseurAct,
        ActualitesClients,
        ActualitesAdmin
    },
    mounted() {

    },
    created() {
        this.showFournisseur = authService.getRole() == "Fournisseur";
        this.showClient = authService.getRole() == 'SuperAdmin'
        this.showGestionnaire = authService.getRole() == 'GestionnairePortail'
    },
    methods: {}
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
    .greet-user {
        position: relative;

        .decore-left {
            position: absolute;
            left: 0;
            top: 0;
        }

        .decore-right {
            position: absolute;
            right: 0;
            top: 0;
        }
    }

    @media (max-width: 576px) {

        .decore-left,
        .decore-right {
            width: 140px;
        }
    }
}

/*! rtl:end:ignore */
</style>
